<div class="taxes-success-info">
	@if(!isloading) {
	<button class="clickable-info" (click)="openTaxesInfo()">
		<tax-amount-label [type]="type" [taxWithheld]="taxWithheld"> </tax-amount-label>
		<div>
			<svg-inline src="/assets/images/tax-doc-icon.svg" [alt]="'tax_reimbursement' | translate" />
		</div>
	</button>
	} @else {
	<loading-spinner></loading-spinner>
	}
</div>
